module.exports = __webpack_public_path__ + "img/re.df1be377.svg";